<script>
    import {Pie, mixins} from 'vue-chartjs'
    import ChartJsPluginDataLabels from 'chartjs-plugin-labels';

    const {reactiveProp} = mixins

    export default {
        extends: Pie,
        mixins: [reactiveProp],
        components: {
            ChartJsPluginDataLabels
        },
        props: {
            chartData: {
                type: Object,
                default: null
            }
        },
        mounted() {
            this.renderChart(this.chartData, {
                legend: {
                    position: 'bottom'
                },
                plugins: {
                    labels: {
                        render: 'value',
                        fontColor: 'black'
                    }
                },
                onClick: this.handle
            })
        },
        methods: {
            handle(point, event) {
                //Enkel als er op de chart zelf geklikt wordt call doen, niet bij legende
                if (event.length) {
                    this.$store.dispatch('CALL_CHART_MODAL_DATA', {
                        chart: this.chartData.listName,
                        chart_item: event[0]._model.label,
                        chart_title: 'Status distribution - ' + event[0]._model.label
                    })
                }
            }
        }
    }
</script>
